import { IKpiPresetWeight } from './kpi-preset-weight.model';

export interface IKpiConfWeight {
  id?: number;
  value?: number | null;
  valueMin?: number | null;
  valueMax?: number | null;
  kpiPresetWeight?: IKpiPresetWeight | null;
  kpiEvent?: {
    id: number;
    eventType: string;
    kpiMain?: {
      id: number;
      name: string;
      kpiInfo?: string;
      kpiValueMin?: number;
      kpiValueMax?: number;
    };
  } | null;
}

export const defaultValue: Readonly<IKpiConfWeight> = {};
